import React, { useState, useEffect, useRef } from 'react'

//Dependencies.
import { Alert, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { v4 } from 'uuid';

//Functions.
  //Slices.
  import { useDispatch, useSelector } from 'react-redux';
  //Callback function.
  import { loggedInUser } from '../../../slices/allUsersSlice';
  //Action Creators.
  import { addNewVideo, addVideoToDBThunk, addVideoToFS } from '../../../slices/allVideosSlice';

import './AddVideo.styles.css';


const AddVideoForm = ({ toggle }) => {
   const [videoURLDetails, setVideoURLDetails] = useState({ source: "", urlLink: null });

   const currentUser = useSelector(loggedInUser);
   const dispatch = useDispatch();

   const videoTitleRef = useRef();
   const descriptionRef = useRef();
   let linkRef = useRef();

   useEffect(() => {
      console.log(videoURLDetails);
      return () => {

      };
   }, [videoURLDetails.source]);

   async function handleVideoSubmission(e) {
      e.preventDefault();

      const { _userID } = currentUser;
      const _videoID = `_userID${_userID}_videoID${v4()}`;

      const videoObject = {
         _videoID,
         _userID,
         title: videoTitleRef.current.value.length > 31
            ?
            videoTitleRef.current.value.substring(0, 31) + "..."
            :
            videoTitleRef.current.value,
         descriptionRef: descriptionRef.current.value.length > 39
            ?
            descriptionRef.current.value.substring(0, 39) + "..."
            :
            descriptionRef.current.value,
         link: videoURLDetails.urlLink 
            ? 
            videoURLDetails.urlLink 
            : 
            linkRef.current.value,
         source: videoURLDetails.source,
         record: { wins: 0, losses: 0, ties: 0, winPct: 0 }
      }

      console.log(videoObject);
      await dispatch(addVideoToFS(videoObject));
      toggle();
      e.target.reset() //resets AddVideoForm after the dispatch and toggle is done.
   }
   
   return (
      <Form style={{
         padding: "1.5%",
         margin: "5%",
         border: "3.5px solid red",
         backgroundColor: "whitesmoke",
         borderRadius: "15px",
         width: '33%',
         height: videoURLDetails.source === "computer" ? "107%" : "83%"
      }} onSubmit={handleVideoSubmission}>
         <FormGroup>
            <Label htmlFor='title'>VIDEO TITLE</Label>
            <Input type='text' id='title' required innerRef={videoTitleRef} defaultValue="Nothing is going to stop us now (cover)." />
         </FormGroup> {/* title. */}

         <FormGroup>
            <Label htmlFor='description'>DESCRIPTION OF YOUR VIDEO.</Label>
            <Input type='textarea' id='description' name='text' style={{border: '1.5px solid black'}} innerRef={descriptionRef} defaultValue="Cover for Nothing's going to stop us now." />
         </FormGroup> {/* description. */}

         <FormGroup>
            <Row style={{textAlign: 'center'}}>
               <Col><h3>Where will you be getting your video from?</h3></Col>
            </Row>
            <Row>
               <Col sm={6}>
                  <Input type='radio' name='videoUrlSource' value="computer" required style={{border: "3px solid black"}} onChange={(e) => setVideoURLDetails({...videoURLDetails, source: e.target.value})} />
               </Col>
               <Col sm={6}>
                  {' '} <Label check><strong>From Computer.</strong>.</Label>
               </Col>
            </Row>
            <Row>
               <Col sm={6}>
                  <Input type='radio' name='videoUrlSource' value='YouTube' style={{border: "3px solid black"}} onChange={e => setVideoURLDetails({...videoURLDetails, source: e.target.value})} />
               </Col>
               <Col sm={6}>
                  {' '} <Label check><strong>YouTube (url).</strong>.</Label>
               </Col>
            </Row>
         </FormGroup> {/* source of the video. */}

         {
            (videoURLDetails.source === "computer")
            &&
            <FormGroup>
               <Label htmlFor='computer'>Upload Your <strong className='text-danger'>VIDEO FILE</strong> From Your <strong><em>COMPUTER</em></strong>.</Label>
               <Alert color='danger'>Warning: It is <em>highly recommended</em> that you upload your video to You-Tube <em>first</em> and then select the You-Tube option since video quality from your desktop/laptop may result in unpredictable qualities.</Alert>
               <Input type='file' id='computer' onChange={ e => setVideoURLDetails({...videoURLDetails, urlLink: e.target.files[0]}) } required />
            </FormGroup> //upload video from computer.
         }

         {
            (videoURLDetails.source === "YouTube")
            &&
            <FormGroup>
               <Label htmlFor='YouTube'>Insert <strong>URL</strong> From <strong><em>YouTube</em></strong>.</Label>
               <Input type='text' id='YouTube' innerRef={linkRef} onChange={e => console.log(e.target.value)} required defaultValue="https://www.youtube.com/watch?v=DuVaLWf2114" />
            </FormGroup> //Copy & paste from YouTube.
         }

         <div className="d-grid gap-2">
            <button className="btn btn-danger" type="submit">ADD NEW VIDEO!!!</button>
         </div>
      </Form>
   )
}

export default AddVideoForm;